var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcpp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#EDFAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6719 56.1526H50.0033C52.2125 56.1526 54.0033 54.3617 54.0033 52.1526V27.3237C54.0033 26.534 53.7696 25.7619 53.3315 25.1049L46.6079 15.0195C45.8661 13.9067 44.6171 13.2383 43.2797 13.2383H23.6719C21.4627 13.2383 19.6719 15.0291 19.6719 17.2383V52.1526C19.6719 54.3617 21.4627 56.1526 23.6719 56.1526Z",
    fill: "#A6E4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3945,
    y: 34.418,
    width: 21.893,
    height: 1.71657,
    rx: 0.858286,
    fill: "#26B0EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3945,
    y: 37.8516,
    width: 21.893,
    height: 1.71657,
    rx: 0.858286,
    fill: "#26B0EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0898,
    y: 44.7168,
    width: 22.1965,
    height: 1.71657,
    rx: 0.858286,
    fill: "#26B0EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0898,
    y: 41.2852,
    width: 12.9273,
    height: 1.71657,
    rx: 0.858286,
    fill: "#26B0EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3945,
    y: 30.9844,
    width: 21.893,
    height: 1.71657,
    rx: 0.858286,
    fill: "#26B0EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4004 22.1328C27.4004 23.7495 26.3989 24.6758 25.0898 24.6758C23.7705 24.6758 22.7725 23.7427 22.7725 22.1328C22.7725 20.5161 23.7705 19.5898 25.0898 19.5898C26.3989 19.5898 27.4004 20.5161 27.4004 22.1328ZM23.8184 22.1328C23.8184 23.189 24.3208 23.7632 25.0898 23.7666C25.8521 23.7632 26.3579 23.189 26.3545 22.1328C26.3579 21.0732 25.8521 20.5024 25.0898 20.499C24.3208 20.5024 23.8184 21.0732 23.8184 22.1328ZM31.4473 21.3809C31.3652 20.834 30.9448 20.5024 30.3672 20.499C29.5981 20.5024 29.0889 21.0903 29.0889 22.1328C29.0889 23.1992 29.605 23.7632 30.3604 23.7666C30.9243 23.7632 31.3481 23.4556 31.4473 22.9189L32.4863 22.9258C32.3735 23.8418 31.6045 24.6758 30.3467 24.6758C29.0239 24.6758 28.043 23.7427 28.043 22.1328C28.043 20.5161 29.041 19.5898 30.3467 19.5898C31.4883 19.5898 32.3496 20.2427 32.4863 21.3809H31.4473ZM33.2041 24.6074V19.6582H35.1455C36.27 19.6582 36.916 20.3521 36.916 21.3262C36.916 22.314 36.2598 22.9941 35.1182 22.9941H34.2295V24.6074H33.2041ZM34.2295 22.167H34.9541C35.5625 22.167 35.8599 21.8252 35.8564 21.3262C35.8599 20.834 35.5625 20.5024 34.9541 20.499H34.2295V22.167ZM37.5654 24.6074V19.6582H39.5068C40.6313 19.6582 41.2773 20.3521 41.2773 21.3262C41.2773 22.314 40.6211 22.9941 39.4795 22.9941H38.5908V24.6074H37.5654ZM38.5908 22.167H39.3154C39.9238 22.167 40.2212 21.8252 40.2178 21.3262C40.2212 20.834 39.9238 20.5024 39.3154 20.499H38.5908V22.167Z",
    fill: "#26B0EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2791 25.9968L45.1172 16.7539C44.5684 15.9307 43.2852 16.3192 43.2852 17.3086V26.5515C43.2852 27.1038 43.7329 27.5515 44.2852 27.5515H50.4471C51.2458 27.5515 51.7222 26.6614 51.2791 25.9968Z",
    fill: "#6BD3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9805 37.5156H27.1854V50.4025L22.5829 47.8251L17.9805 50.4025V37.5156Z",
    fill: "#FF9500"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5868,
    cy: 34.8954,
    r: 8.08286,
    fill: "#FFCC00",
    stroke: "#FFE066"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0166 31.5023C22.1962 30.9495 22.9782 30.9495 23.1579 31.5023L23.6087 32.8899C23.689 33.1371 23.9194 33.3045 24.1793 33.3045H25.6383C26.2195 33.3045 26.4612 34.0482 25.991 34.3899L24.8106 35.2474C24.6003 35.4002 24.5123 35.671 24.5927 35.9182L25.0435 37.3058C25.2231 37.8586 24.5904 38.3183 24.1202 37.9766L22.9399 37.1191C22.7296 36.9663 22.4448 36.9663 22.2345 37.1191L21.0542 37.9766C20.584 38.3183 19.9513 37.8586 20.1309 37.3058L20.5818 35.9182C20.6621 35.671 20.5741 35.4002 20.3638 35.2474L19.1835 34.3899C18.7133 34.0482 18.9549 33.3045 19.5362 33.3045H20.9951C21.255 33.3045 21.4854 33.1371 21.5657 32.8899L22.0166 31.5023Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcpp);
export default __webpack_public_path__ + "static/media/ocpp.0068937bf0a0db82e1c99c74081021e0.svg";
export { ForwardRef as ReactComponent };